import * as types from '../../constants/app/itemDBConstants';

export const itemDBUpdatePost = ({
  ConfigFile,
  callback,
  error,
}) => ({
  type: types.ITEM_DB_UPDATE,
  ConfigFile,
  callback,
  error,
});

export const itemDBInfoRequest = ({
  callback,
  error,
}) => ({
  type: types.ITEM_DB_INFO_REQUEST,
  callback,
  error,
});

export const setItemConfig = (materials) => ({
   type: types.SET_ITEM_CONFIG,
    materials,
})